import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { PictureBalanceRechargeContainer } from "./atom";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import {
  OrderPaymentTypeCode,
  PaymentPurposeCode,
  PaymentTypeCode,
  QRCODE_QUERY_MAP,
  Whether,
  rechargeChannelsCode,
} from "project-config/constants";
import { initVerifyRechargeInfo, usePictureTopUpStore } from "../../store";
import { PictureRechargeGift } from "../picture-recharge-gift";
import { useEffect, useMemo, useState } from "react";
import { PictureNormalRecharge } from "../picture-normal-balance-recharge";
import { RechargeInputForm } from "../charge-input-form";
import { PaymentWay } from "../payment-way";
import { RechargeTips } from "../../help/tips";
import { BindActivityInfo } from "@/components/top-up/types";
import { BalanceTipType, ExtraWelfareTipType } from "../../types";
import { useTranslation } from "react-i18next";
import { useCountdown } from "./hooks/useCountDown";
import { TopUpSecondTabs } from "@/components/top-up/components/second-tabs";
import { CommonSecondTabsContent, CommonUpperPart } from "../../atom";
import { NewUserWelfareBar } from "@/components/new-user-welfare-bar";
import { TimesStamp } from "@/constant/TimesStamp";
import { RechargeVoucher } from "../recharge-voucher";
import { useToastStore } from "@/store/toast-store";

export function PictureBalanceRecharge({
  activityInfo,
}: {
  activityInfo?: BindActivityInfo;
}) {
  const { userProperty } = useUserPropertyStore();
  const { showGlobalToast } = useToastStore();
  const { currencySymbol, userInfo, isZh } = useGlobalStore();
  const { t } = useTranslation("topup");
  const { days, hours, minutes, seconds } = useCountdown(
    userInfo?.registerDate ?? 0,
    TimesStamp.DAY * 2
  );
  const { addPayRecord, setter } = usePictureTopUpStore();
  const amount = usePictureTopUpStore((state) => state.amount);
  const paying = usePictureTopUpStore((state) => state.paying);
  const rechargeSecondActiveName = usePictureTopUpStore(
    (state) => state.rechargeSecondActiveName
  );
  const verifyRechargeInfo = usePictureTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const { couponNO, activityId, rechargeAmount } = verifyRechargeInfo;
  const [searchParams] = useSearchParams();
  const goal = useMemo(
    () =>
      rechargeSecondActiveName === "second-tab-first-recharge"
        ? PaymentPurposeCode.FirstRecharge
        : activityInfo
        ? PaymentPurposeCode.ActivityRecharge
        : PaymentPurposeCode.OrdinaryRecharge,
    [rechargeSecondActiveName, activityInfo]
  );
  const [balanceTip, setBalanceTip] = useState<BalanceTipType[]>();
  const [extraTip, setExtraTip] = useState<ExtraWelfareTipType[]>();
  const verifyRechargeCode = usePictureTopUpStore(
    (state) => state.verifyRechargeCode
  );

  const onClickCantScanCode = async () => {
    let params = {
      agent: searchParams.get("agent") || "",
      currency: userInfo?.zone,
      payMethod: PaymentTypeCode.Alipay,
      amount: Number(amount),
      rechargeGoal: goal,
      rechargeChannels: rechargeChannelsCode.Web,
    } as any;
    // 二次进行充值兑换判断
    if (couponNO && Number(amount) >= rechargeAmount) {
      params = {
        ...params,
        couponNo: couponNO,
        couponActivityId: activityId,
      };
      const { code } = await verifyRechargeCode({
        couponNO,
        amount: Number(amount),
      });
      if (code !== 200) {
        setter({
          verifyRechargeInfo: initVerifyRechargeInfo,
        });
        showGlobalToast({
          type: "error",
          content: t(`renderbus_coupon_code_tips_${code}`),
        });
        return;
      }
    }
    await addPayRecord(params);
  };

  const qrcodeLink = () => {
    let link = `&${QRCODE_QUERY_MAP.orderType}=${
      OrderPaymentTypeCode.OrdinaryOrder
    }&${QRCODE_QUERY_MAP.amount}=${Number(amount)}&${
      QRCODE_QUERY_MAP.rechargeGoal
    }=${goal}`;
    if (couponNO && Number(amount) >= rechargeAmount) {
      link += `&${QRCODE_QUERY_MAP.couponNO}=${couponNO}`;
    }
    return link;
  };

  const getRechargeSecondTabList = () => {
    let list = [];
    list.push(
      activityInfo
        ? {
            label: isZh
              ? activityInfo.activityName
              : activityInfo.activityNameEn,
            key: "second-tab-activity-recharge",
            children: (
              <>
                <CommonUpperPart>
                  <PictureRechargeGift activityInfo={activityInfo} />
                  <RechargeInputForm />
                  {/* 充值兑换券 */}
                  <RechargeVoucher />
                </CommonUpperPart>
                <PaymentWay
                  paying={paying}
                  onClickCantScanCode={onClickCantScanCode}
                  qrcodeLink={qrcodeLink()}
                  balanceTip={balanceTip}
                  extraTip={extraTip}
                />
              </>
            ),
          }
        : {
            label: t("topUp_balance_title"),
            key: "second-tab-balance-recharge",
            children: (
              <>
                <CommonUpperPart>
                  <PictureNormalRecharge />
                  <RechargeInputForm />
                  {/* 充值兑换券 */}
                  <RechargeVoucher />
                </CommonUpperPart>
                <PaymentWay
                  paying={paying}
                  onClickCantScanCode={onClickCantScanCode}
                  qrcodeLink={qrcodeLink()}
                  balanceTip={balanceTip}
                  extraTip={extraTip}
                />
              </>
            ),
          }
    );
    // 取消效果图首充活动
    // if (userProperty?.isFirstRecharge === Whether.No) {
    //   list.unshift({
    //     label: t("topup_first_recharge_text"),
    //     key: "second-tab-first-recharge",
    //     children: (
    //       <>
    //         <CommonUpperPart>
    //           <PictureFirstRecharge />
    //         </CommonUpperPart>
    //         <PaymentWay
    //           paying={paying}
    //           onClickCantScanCode={onClickCantScanCode}
    //           qrcodeLink={qrcodeLink()}
    //           balanceTip={balanceTip}
    //           extraTip={extraTip}
    //         />
    //       </>
    //     ),
    //   });
    // }
    return list;
  };

  useEffect(() => {
    const rechargeTips = new RechargeTips({
      amount: Number(amount),
      userProperty,
      currencySymbol,
      activityInfo,
      rechargeSecondActiveName,
      verifyRechargeInfo,
    });
    rechargeTips.init();
    setBalanceTip(rechargeTips.balanceTip);
    setExtraTip(rechargeTips.extraWelfareTip);
  }, [
    amount,
    userProperty,
    currencySymbol,
    activityInfo,
    rechargeSecondActiveName,
    verifyRechargeInfo,
  ]);

  useEffect(() => {
    setter((state) => {
      state.rechargeSecondActiveName = getRechargeSecondTabList()[0].key;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PictureBalanceRechargeContainer>
      {/* 限时福利 */}
      {userProperty.picRechargeOver === Whether.No && (
        <NewUserWelfareBar
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
          tips={t("picture_new_user_welfare_tip")}
        />
      )}
      <CommonSecondTabsContent>
        <TopUpSecondTabs
          tabsList={getRechargeSecondTabList()}
          activeKey={rechargeSecondActiveName}
          onChange={(k) => {
            setter((state) => {
              state.rechargeSecondActiveName = k;
            });
          }}
        />
      </CommonSecondTabsContent>
    </PictureBalanceRechargeContainer>
  );
}
